// Generated from onedeskFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by onedeskFormula.
export default class onedeskFormulaListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by onedeskFormula#root.
	enterRoot(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#root.
	exitRoot(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#FieldReference.
	enterFieldReference(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#FieldReference.
	exitFieldReference(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#StringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#StringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#Brackets.
	enterBrackets(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#Brackets.
	exitBrackets(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#BooleanLiteral.
	enterBooleanLiteral(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#BooleanLiteral.
	exitBooleanLiteral(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#RightWhitespaceOrComments.
	enterRightWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#RightWhitespaceOrComments.
	exitRightWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#DecimalLiteral.
	enterDecimalLiteral(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#DecimalLiteral.
	exitDecimalLiteral(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#LeftWhitespaceOrComments.
	enterLeftWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#LeftWhitespaceOrComments.
	exitLeftWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#FunctionCall.
	enterFunctionCall(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#FunctionCall.
	exitFunctionCall(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#FieldByIdReference.
	enterFieldByIdReference(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#FieldByIdReference.
	exitFieldByIdReference(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#LookupFieldReference.
	enterLookupFieldReference(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#LookupFieldReference.
	exitLookupFieldReference(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#IntegerLiteral.
	enterIntegerLiteral(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#IntegerLiteral.
	exitIntegerLiteral(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#BinaryOp.
	enterBinaryOp(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#BinaryOp.
	exitBinaryOp(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#ws_or_comment.
	enterWs_or_comment(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#ws_or_comment.
	exitWs_or_comment(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#func_name.
	enterFunc_name(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#func_name.
	exitFunc_name(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#field_reference.
	enterField_reference(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#field_reference.
	exitField_reference(ctx) {
	}


	// Enter a parse tree produced by onedeskFormula#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by onedeskFormula#identifier.
	exitIdentifier(ctx) {
	}



}